module.exports = __webpack_public_path__ + "img/phlix-large.a32f1b86.svg";